/**
 * @generated SignedSource<<e25536290fed122b36627f9024b4fde7>>
 * @relayHash a94de81c04a5ca0ee498c4b43bd0b87e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 59579c0cbce680227e7e004f19597a1cb936a924ff0a90d7bde7bec6b2353a3e

import type { ConcreteRequest } from 'relay-runtime';
export type useViewPageRovoActionsGetUserJobTitleQuery$variables = Record<PropertyKey, never>;
export type useViewPageRovoActionsGetUserJobTitleQuery$data = {
  readonly user: {
    readonly id: string | null | undefined;
    readonly title: string | null | undefined;
  } | null | undefined;
};
export type useViewPageRovoActionsGetUserJobTitleQuery = {
  response: useViewPageRovoActionsGetUserJobTitleQuery$data;
  variables: useViewPageRovoActionsGetUserJobTitleQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": "user",
    "args": [
      {
        "kind": "Literal",
        "name": "current",
        "value": true
      }
    ],
    "concreteType": "AtlassianUser",
    "kind": "LinkedField",
    "name": "confluence_atlassianUser",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "title"
      }
    ],
    "storageKey": "confluence_atlassianUser(current:true)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useViewPageRovoActionsGetUserJobTitleQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useViewPageRovoActionsGetUserJobTitleQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "a94de81c04a5ca0ee498c4b43bd0b87e",
    "id": "59579c0cbce680227e7e004f19597a1cb936a924ff0a90d7bde7bec6b2353a3e",
    "metadata": {},
    "name": "useViewPageRovoActionsGetUserJobTitleQuery",
    "operationKind": "query",
    "text": "query useViewPageRovoActionsGetUserJobTitleQuery{user:confluence_atlassianUser(current:true){id,title}}"
  }
};
})();

(node as any).hash = "5161add4babe6275214e15eeadece7c3";

export default node;
